import * as React from "react";
import * as uuid from "uuid";

import { DrawerViewModel, DrawerViewProps } from "../../Common";
import {
  useDrawerDelivery,
  useDrawerDelivery_asController,
} from "../providers";

export const DrawerFragment_Delivery_ViewModel: DrawerViewProps["useDrawerViewModel"] =
  () => {
    const { drawerShouldBePresenting } = useDrawerDelivery();
    const { handleClose: drawerDelivery_handleClose } =
      useDrawerDelivery_asController();

    const this_guid = React.useMemo(() => {
      return uuid.v4();
    }, []);

    const handleClose = React.useCallback(() => {
      drawerDelivery_handleClose();
    }, [drawerDelivery_handleClose]);

    const present = React.useMemo(() => {
      return drawerShouldBePresenting;
    }, [drawerShouldBePresenting]);

    const className = React.useMemo(() => {
      return `bbnt-checkout-2022 delivery`;
    }, []);

    const value: DrawerViewModel = React.useMemo(
      () => ({
        guid: this_guid,
        present,
        className,
        handleClose,
      }),
      [this_guid, present, className, handleClose]
    );
    return value;
  };
